import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersKEmployeeConditionSubmissionsLikedEmployeesIndexResponseType } from "~/domains";

type RequestDataType = {
  employeeConditionSubmissionId: string;
  page?: number;
};

const request = async ({
  employeeConditionSubmissionId,
  page = 1,
}: RequestDataType): Promise<ApiMembersKEmployeeConditionSubmissionsLikedEmployeesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersKEmployeeConditionSubmissionsLikedEmployeesIndexResponseType>(
      `/api/members/employee_condition_submissions/${employeeConditionSubmissionId}/liked_employees`,
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  employeeConditionSubmissionId: string;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersEmployeeConditionSubmissionsLikedEmployeesIndex = ({
  employeeConditionSubmissionId,
  config = {},
}: PropsType): UseInfiniteQueryResult<ApiMembersKEmployeeConditionSubmissionsLikedEmployeesIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    [
      "ApisMembersEmployeeConditionSubmissionsLikedEmployeesIndex",
      employeeConditionSubmissionId,
    ],
    ({ pageParam }) => {
      return request({
        employeeConditionSubmissionId,
        page: pageParam as number | undefined,
      });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
